import { useState, useEffect } from 'react';
import { tokenManager } from '../config/authConfig';
import API_CIFRA from '../config/Variables_apis';

const useVias = () => {
  const [vias, setVias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Función para obtener headers de autenticación
  const getAuthHeaders = () => {
    const token = tokenManager.getAccessToken();
    const headers = {
      "Content-Type": "application/json",
    };
    
    if (token && !tokenManager.isTokenExpired()) {
      headers.Authorization = `Bearer ${token}`;
    }
    
    return headers;
  };

  // Función para manejar errores específicos
  const handleApiError = (error, response) => {
    let errorMessage = "Error al cargar las vías";
    
    if (response?.status === 400) {
      errorMessage = "Datos inválidos.";
    } else if (response?.status === 401) {
      errorMessage = "Error de autenticación.";
    } else if (response?.status === 403) {
      errorMessage = "No tienes permisos para acceder a las vías.";
    } else if (response?.status === 404) {
      errorMessage = "Vías no encontradas.";
    } else if (response?.status === 500) {
      errorMessage = "Error interno del servidor.";
    }
    
    return errorMessage;
  };

  // Función para cargar vías
  const cargarVias = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log('API_CIFRA.via:', API_CIFRA.via);
      console.log('API_CIFRA.via.listar:', API_CIFRA.via?.listar);
      
      const response = await fetch(API_CIFRA.via.listar, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      const data = await response.json();
      console.log('Respuesta del backend (vías):', data);

      if (!response.ok) {
        const errorMessage = handleApiError(null, response);
        throw new Error(data.error || data.detail || errorMessage);
      }

      // Asegurar que data sea siempre un array
      let viasArray = [];
      
      if (Array.isArray(data)) {
        viasArray = data;
      } else if (data && typeof data === 'object') {
        // Si es un objeto, intentar extraer el array de vías (formato IDÉNTICO a categorías)
        if (data.vias && Array.isArray(data.vias)) {
          viasArray = data.vias;
        } else if (data.results && Array.isArray(data.results)) {
          viasArray = data.results;
        } else if (data.data && Array.isArray(data.data)) {
          viasArray = data.data;
        }
      }
      
      console.log('Vías procesadas:', viasArray);
      setVias(viasArray);
      return { success: true, data: viasArray };

    } catch (error) {
      const errorMessage = error.message || "Error al cargar vías";
      console.error('Error en useVias:', errorMessage);
      setError(errorMessage);
      return { success: false, error: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  // Función para obtener vía por ID
  const obtenerViaPorId = (id) => {
    return vias.find(via => via.id === id);
  };

  // Función para obtener vía por nombre
  const obtenerViaPorNombre = (nombre) => {
    return vias.find(via => via.via_chNombre === nombre);
  };

  // Cargar vías al montar el hook
  useEffect(() => {
    cargarVias();
  }, []);

  return {
    vias,
    loading,
    error,
    cargarVias,
    obtenerViaPorId,
    obtenerViaPorNombre
  };
};

export default useVias;
